// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --overflow: hidden;
}

.close-button {
  position: fixed;
  top: -10px;
  right: -10px;
  margin: 0;
  z-index: 10;
}

.delete-icon ion-icon {
  padding: 0 4px;
}

h2 {
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/delivery-create/delivery-create.popover.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AACJ;;AAGI;EACI,cAAA;AAAR;;AAIA;EACI,+BAAA;AADJ","sourcesContent":["ion-content {\n    --overflow: hidden;\n}\n\n.close-button {\n    position: fixed;\n    top: -10px;\n    right: -10px;\n    margin: 0;\n    z-index: 10;\n}\n\n.delete-icon {\n    ion-icon {\n        padding: 0 4px;\n    }\n}\n\nh2 {\n    color: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
